import React from 'react'
import firebase from './../Firestore'
import config from 'react-global-configuration';

import AgregarCarrito from './AgregarCarrito';



class ProductoEmpanada extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
      productosLista: [],
      imagenCategoria: ""
     };
   };


imagenCategoria(categoriaId){
  var currentComponent = this;
  var db = firebase.firestore();
  var docRef = db.collection("categoria").doc(categoriaId);

  docRef.get().then(function(doc) {
      if (doc.exists) {
          currentComponent.setState({"imagenCategoria": doc.data().imagen})
      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }
  }).catch(function(error) {
      console.log("Error getting document:", error);
  });

}

   componentWillMount(){
       var db = firebase.firestore();
       db.collection("producto").where("categoriaID", "==", this.props.categoriaId).orderBy("orden", "asc").get().then((snapShots) => {
             this.setState(
               {
                 productosLista: snapShots.docs.map(doc => {
                   return {
                     "nombre": doc.data().nombre,
                     "descripcion": doc.data().descripcion,
                     "id": doc.id,
                     "imagen": doc.data().imagen,
                     "orden": doc.data().orden,
                     "precio": doc.data().precio,
                     "categoriaId": doc.data().categoriaID,
                     "cantidad": 0
                   }
                 }),

               }
             );
       });
       this.imagenCategoria(this.props.categoriaId)


       }


   onChange(event) {

     if(event.target.name === 'subCategoria'){
       this.setState({ productoSeleccionado: event.target.value })
     }else if(event.target.name === 'subCategoria2'){
       this.setState({ idOtraMitad: event.target.value })
     } else if(event.target.name === 'seFracciona'){
         //alert("event checked", event.target.checked)
         this.setState({ esMitad: event.target.checked })
         if(!event.target.checked) this.setState({ idOtraMitad: 0 })
     }

   }

   onClick(event) {

      //event.currentTarget.classList.add("bg-warning");
      var nuevaCantidad
      if(event.target.id === "resta"){
        var actualCantidad = Number(event.currentTarget.dataset.cant);
        if(actualCantidad > 0){
          nuevaCantidad = actualCantidad -1;
          //if(actualCantidad === 1) event.currentTarget.classList.remove("bg-warning");
        }
      }else{
        nuevaCantidad = Number(event.currentTarget.dataset.cant) + 1;
      }

      this.updateItem(event.currentTarget.id, {cantidad: nuevaCantidad});

    }

   updateItem(id, itemAttributes) {
     var index = this.state.productosLista.findIndex(x=> x.id === id);
     if (index === -1){
       // handle error
     }
     else{
       this.setState({
         productosLista: [
            ...this.state.productosLista.slice(0,index),
            Object.assign({}, this.state.productosLista[index], itemAttributes),
            ...this.state.productosLista.slice(index+1)
         ]
       });
     }

   }



   render() {
    //console.log("Productoslista", this.state.productosLista, this.state.productosLista.length)


    var cantTotalEmpanadas = 0;
    var importeTotalEmpanadas = 0;

    for (var index in this.state.productosLista) {
        cantTotalEmpanadas += this.state.productosLista[index].cantidad;
        importeTotalEmpanadas += this.state.productosLista[index].cantidad * this.state.productosLista[index].precio
    }
    //console.log(cantTotalEmpanadas, importeTotalEmpanadas )

    const itemsSeleccionados = this.state.productosLista.filter(function(item) {
      return item.cantidad > 0;
      });

      const itemsSinSeleccionar = this.state.productosLista.filter(function(item) {
        return item.cantidad === 0;
        });

    //const Items = this.state.productosLista.map((todo, i) =>
    const ItemsNoSel = itemsSinSeleccionar.map((todo, i) =>

      <tr id={todo.id} key={todo.id} data-cant={itemsSinSeleccionar[i].cantidad} onClick={event => this.onClick(event)}>
        <td className="py-3">
          <i id="suma" className="fas fa-arrow-alt-circle-up fa-2x text-primary"></i>
        </td>
        <td className="py-3">
          <strong>{todo.nombre}</strong> <span>{todo.descripcion}</span>
        </td>
        <td className="py-3">
            <span className="text-muted">${todo.precio}</span>

        </td>
        <td className="py-3">

        </td>
      </tr>

    );

    const ItemsSel = itemsSeleccionados.map((todo, i) =>

      <tr id={todo.id} key={todo.id} data-cant={itemsSeleccionados[i].cantidad} onClick={event => this.onClick(event)}>
        <td className="py-3">
          <i id="suma" className="fas fa-plus-circle fa-2x text-success"></i>
        </td>
        <td className="py-3">
          <strong>{itemsSeleccionados[i].cantidad > 0 ? itemsSeleccionados[i].cantidad : "" }</strong>{itemsSeleccionados[i].cantidad > 0 ? " de " : "" }<strong>{todo.nombre}</strong> <span>{todo.descripcion}</span>
        </td>
        <td className="py-3">

          {itemsSeleccionados[i].cantidad > 0 ? (
            <span>${todo.precio * itemsSeleccionados[i].cantidad}</span>
          ) : (
            <span className="text-muted">${todo.precio}</span>
            )}

        </td>
        <td className="py-3">


          {itemsSeleccionados[i].cantidad > 0 ? (
            <i id="resta" className="fas fa-minus-circle fa-2x text-danger"></i>
          ) : (
            <span></span>
            )}

        </td>
      </tr>

    );


    var imagenCategoria;
    if(this.state.imagenCategoria){
      imagenCategoria = this.state.imagenCategoria
    }else {
      imagenCategoria = ""
    }

    return (

      <table className="table table-sm">
        <thead>

          <tr>
            <td colSpan="4" className="text-center">

              {imagenCategoria !== "" &&
                <img src={imagenCategoria} className="img-fluid rounded d-block mx-auto" alt={ config.get('tienda').nombre } />
              }

            {cantTotalEmpanadas === 0 ? (
              <span>Tocando <i id="suma" className="fas fa-arrow-alt-circle-up text-primary"></i> la agregas al pedido</span>
            ) : (
              <span>Tocando <i id="suma" className="fas fa-plus-circle text-success"></i> suma la cantidad</span>
            )}

            </td>

          </tr>
        </thead>

        <tbody>

            {ItemsSel}
            {cantTotalEmpanadas > 0 &&
              <tr>
                <td colSpan="4" className="text-center">
                  <small>Seleccionadas <span className="badge badge-pill badge-primary">{cantTotalEmpanadas}</span> empanadas por $ {importeTotalEmpanadas}</small>
                  <AgregarCarrito texto="Listo las empanadas!" uid={this.props.uid} diseno={this.props.diseno} productosLista={this.state.productosLista} adicionalesSeleccionados={this.state.adicionalesSeleccionados}/>
                </td>
              </tr>
            }

              {ItemsNoSel}

        </tbody>
        </table>

    );
  }
}

export default ProductoEmpanada
